import type { SessionSimulationAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type GroupBy,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryLimitToSQL,
  queryOrderToSQL,
} from './common'

const SessionSimulationQ = {
  ...makeQueryModelV2<SessionSimulationAttributes>('session_simulation')([
    'id',
    'user_id',
    'slug',
    'feedback_sentiment',
    'feedback_comment',
    'ended_at',
    'created_at',
    'updated_at',
    'deleted_at',
  ]),

  where: (
    {
      paranoid = true,
      userId,
      include = [],
      groupBy = null,
      order = null,
      limit = null,
    }: {
      paranoid?: boolean
      userId?: number | SQLFragment<number>
      include?: IncludeAssociations
      groupBy?: GroupBy | null
      order?: QueryOrder | null
      limit?: number | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<SessionSimulationAttributes> => SQL`
        FROM ${SessionSimulationQ}
        ${includeAssociationsToSql(SessionSimulationQ, include)}
        WHERE
            ${paranoid ? SQL`${SessionSimulationQ.deleted_at} IS NULL AND` : SQL``}
            ${userId != null ? SQL`${SessionSimulationQ.user_id} = ${userId} AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
        ${queryLimitToSQL(limit)}
    `,
}

export default SessionSimulationQ
